import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import TasksService from 'mt-react-common/modules/tasks/services/TasksService/TasksService';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class TasksHighlightForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      days: '',
      errors: null
    };
  }

  sendForm = () => {
    this.props.setLoading(true);
    TasksService.highlightTask(this.props.taskModel.id, this.state.days).then(
      result => {
        if (result) {
          if (result.status === 200) {
            this.props.updateTask();
            this.props.updateAccountInfo();
            this.setState({ days: '', errors: null });
            this.props.addClientNotice({
              type: 'success',
              message: result.data.message
            });
          } else if (result.status === 422) {
            this.setState({ errors: _.groupBy(result.data, 'field') });
          } else if ([400, 423, 403].includes(result.status)) {
            this.props.addClientNotice({
              type: 'danger',
              message: result.data.message
            });
          }
        }
        this.props.setLoading(false);
      }
    );
  };

  render() {
    const hasError = field => this.state.errors && this.state.errors[field];
    const errorDesc = field => {
      if (hasError(field)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {this.state.errors[field][0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <article
        className={`panel ${
          !this.props.taskModel.upListMarkNow
            ? 'panel-default'
            : 'panel-success'
        }`}
      >
        <div className="panel-heading text-center panel-inner-border-bottom">
          <div className="panel-title">
            <i className="fa fa-eye m-r-4" /> {t('Выделить задание')}
          </div>
        </div>
        <div className="p-b-5 panel-body">
          <p className="">
            {t(
              'Выделенное задание заметнее в списке и привлекает больше исполнителей.'
            )}
          </p>

          <div className="row">
            <div className="col-xs-24 col-sm-16">
              <div className="form-group">
                <label className="control-label" htmlFor="none">
                  {t('Количество дней')}:
                </label>
                <input
                  className="form-control ng-untouched ng-pristine ng-valid"
                  type="number"
                  min="1"
                  max="10"
                  value={this.state.days}
                  onChange={e => {
                    if (hasError('days')) {
                      const errors = this.state.errors.days;
                      delete errors.days;
                      this.setState({ days: e.target.value, errors });
                    } else {
                      this.setState({ days: e.target.value });
                    }
                  }}
                />
                {errorDesc('days')}
              </div>
            </div>
            <div className="col-xs-24 col-sm-8">
              <div className="form-group">
                <label className="control-label hidden-xs" htmlFor="none">
                  &nbsp;
                </label>
                <button
                  className="btn btn-block btn-primary"
                  onClick={this.sendForm}
                  disabled={this.state.days === ''}
                >
                  {this.props.tasksUpListType.day_cost * this.state.days}{' '}
                  <i className="fa fa-rub" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="panel-footer">
          <div className="row">
            <div className="col-xs-24">
              {this.props.taskModel.upListMarkNow ? (
                <div className="form-control-static text-success">
                  {t('Задание выделено до')}:{' '}
                  <strong>
                    {formatter.dateFormat5(
                      this.props.taskModel.upListMarkNow.andTime
                    )}
                  </strong>
                </div>
              ) : (
                <div className="form-control-static text-muted">
                  {t('Задание не выделено')}
                </div>
              )}
            </div>
          </div>
        </div>
      </article>
    );
  }
}

TasksHighlightForm.contextTypes = {};

TasksHighlightForm.defaultProps = {};

TasksHighlightForm.propTypes = {
  // IN
  taskModel: PropTypes.shape({
    id: PropTypes.number,
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string
    })
  }).isRequired,
  updateTask: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  // Connect
  tasksUpListType: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    day_cost: PropTypes.string.isRequired
  }).isRequired,
  updateAccountInfo: PropTypes.func.isRequired,
  addClientNotice: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  tasksUpListType: getItemFromRefList(state, 'tasksUpListTypes').find(
    i => i.id === 2
  )
});

const mapDispatchToProps = dispatch => ({
  updateAccountInfo: () => dispatch(sendGetAuthAccountDataRequest()),
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksHighlightForm);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksUpListPopUpNew/forms/TasksHighlightForm.js